import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { SetInitialStateFacade } from '../../../common';
import { AnnouncementState } from './announcements.state';
import { AnnouncementsInitialState, AnnouncementsLoad } from './announcements.actions';

@Injectable({ providedIn: 'root' })
export class AnnouncementsFacade implements SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(AnnouncementState.getLoaded);
  announcements$: Observable<string> = this.store.select(AnnouncementState.getAnnouncement);

  constructor(private store: Store) {}

  loadAnnouncement(): void {
    this.store.dispatch(new AnnouncementsLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new AnnouncementsInitialState());
  }
}
